import { render, staticRenderFns } from "./LanguagesTranslationsItems.vue?vue&type=template&id=053bb51f&scoped=true&"
import script from "./LanguagesTranslationsItems.vue?vue&type=script&lang=js&"
export * from "./LanguagesTranslationsItems.vue?vue&type=script&lang=js&"
import style0 from "./LanguagesTranslationsItems.vue?vue&type=style&index=0&id=053bb51f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053bb51f",
  null
  
)

export default component.exports